import { render, staticRenderFns } from "./Compra_Detallada.vue?vue&type=template&id=20152612"
import script from "./Compra_Detallada.vue?vue&type=script&lang=js"
export * from "./Compra_Detallada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports